const QUESTION_TYPE_PICKLIST = 'picklist';
const QUESTION_TYPE_TEXT = 'text';
const QUESTION_TYPE_STEP = 'step';
const QUESTION_TYPE_GROUP = 'group';
const QUESTION_TYPE_LOOP = 'loop';
const QUESTION_TYPE_STATIC = 'static'; // only display questions

const types = {
  QUESTION_TYPE_PICKLIST,
  QUESTION_TYPE_TEXT,
  QUESTION_TYPE_STEP,
  QUESTION_TYPE_GROUP,
  QUESTION_TYPE_LOOP,
  QUESTION_TYPE_STATIC,
}

export default types;
